"use strict";

var _toConsumableArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var get_image_objects_1 = require("./get-image-objects");

var DEFAULT_IMAGE_MAX_WIDTH = 1080;

var getMediaImageData = function getMediaImageData(_ref) {
  var _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? [200, 400, 600] : _ref$breakpoints,
      _ref$chained = _ref.chained,
      chained = _ref$chained === void 0 ? [] : _ref$chained,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? DEFAULT_IMAGE_MAX_WIDTH : _ref$maxWidth,
      media = _ref.media,
      _ref$transformations = _ref.transformations,
      transformations = _ref$transformations === void 0 ? [] : _ref$transformations;
  var max = media.width ? Math.min(media.width, maxWidth) : maxWidth;
  var sizes = "(max-width: ".concat(max, "px) 100vw, ").concat(max, "px");
  var src = (0, get_image_objects_1.getImageURL)({
    chained: chained,
    transformations: transformations,
    origin: media.origin,
    path: media.pathname
  });
  var aspectRatio = (0, get_image_objects_1.getAspectRatio)(transformations, media.width && media.height ? media.width / media.height : 1);
  var cleaned = breakpoints.concat(max).filter(function (w) {
    return w <= max;
  }).sort(function (a, b) {
    return a - b;
  });

  var deduped = _toConsumableArray(Array.from(new Set(cleaned)));

  var srcSet = deduped.map(function (breakpointWidth) {
    var url = (0, get_image_objects_1.getImageURL)({
      chained: chained,
      origin: media.origin,
      path: media.pathname,
      transformations: transformations.concat("w_".concat(breakpointWidth))
    });
    return "".concat(url, " ").concat(breakpointWidth, "w");
  }).join();
  return {
    height: max / aspectRatio,
    images: {
      sizes: sizes,
      src: src,
      srcSet: srcSet
    },
    width: max
  };
};

exports.default = getMediaImageData;